export default "__VITE_ASSET__DFDtrmkW__"